import React from 'react';
import StarListQuery from '../../../components/starListQuery/starListQuery';
import styles from './starList.module.scss';

class StarList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalNum: window.sessionStorage.getItem('totalStar') || 0
    }
  }

  gotoRegular = () => {
    this.props.history.push({pathname: '/m/starInstruction', search: window.location.search});

  }

  componentDidMount() {
    // console.log(this.props, 'this.props')
  }

  render() {
    const { totalNum } = this.state;
    return (
      <div className={styles.starList}>
        <header className={styles.header}>
          <div className={styles.totalNum}><span className={styles.totalDesc}>共有</span><span className={styles.num}>{totalNum}</span><i></i></div>
          <div className={styles.gotoRegular} onClick={() => this.gotoRegular()}>
            <span>星星规则</span>
            <i className={styles.regularIcon}></i>
          </div>
        </header>
        <StarListQuery />
      </div>
    )
  }
}
export default StarList;